import { cn } from "@/lib/utils";
import { cva } from "class-variance-authority";
import * as React from "react";
import { MULTILINE_MAX_LENGTH } from "@/utils/sanitize/limits";
import { Spinner } from "./spinner";
import {
  CustomLabel,
  type CustomLabelPropsType,
} from "@/components/common/customLabel";

export interface TextAreaProps
  extends React.InputHTMLAttributes<HTMLTextAreaElement>,
    CustomLabelPropsType {
  className?: string;
  classNameParent?: string;
  variant?: "default" | "destructive";
  type?: string;
  error?: string; // Add this line
  touched?: boolean; // Add this line
  isLoading?: boolean; // Add this line
  rows?: number;
}

const textAreaVariants = cva(
  `bg-white  
  placeholder:text-bg+3  
  flex 
  min-h-[60px] 
  w-full 
  rounded-md 
  border 
  border-ring 
  px-3 
  py-2

  shadow-sm 
  focus-visible:outline-none 
  focus-visible:ring-1 
  focus-visible:ring-ring 

  disabled:cursor-not-allowed 
  disabled:bg-bg+1
  disabled:text-fg-muted
  text-base 
  lg:text-sm

  `,
  {
    variants: {
      variant: {
        default: "",
        destructive: "border-de+1 !bg-de-3 placeholder:text-de+1 text-de+1",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

// const Textarea = React.forwardRef<
//   HTMLTextAreaElement,
//   React.ComponentProps<"textarea">
// >(
const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  TextAreaProps // Updated to use TextAreaProps
>(
  (
    {
      className,
      classNameParent,
      variant,
      error,
      touched,
      isLoading,
      disabled,
      label,
      labelClassName,
      subLabel,
      subLabelClassName,
      labelTooltip,
      icon,
      ...props
    },
    ref,
  ) => {
    // Same length the database stores; the user is told when the text reaches it.
    const lengthLimit = props.maxLength ?? MULTILINE_MAX_LENGTH;
    const currentLength = typeof props.value === "string" ? props.value.length : 0;

    return (
      <div className={cn(classNameParent)}>
        <CustomLabel
          label={label}
          labelClassName={labelClassName}
          subLabel={subLabel}
          subLabelClassName={subLabelClassName}
          labelTooltip={labelTooltip}
          icon={icon}
        />
        <textarea
          className={cn(
            textAreaVariants({
              variant: error && touched ? "destructive" : variant,
            }),
            className,
            "resize-none",
          )}
          ref={ref}
          placeholder="Digita..."
          disabled={isLoading || disabled}
          {...props}
          maxLength={lengthLimit}
        />
        {currentLength >= lengthLimit && (
          <p role="alert" className="text-xs text-de+1 mt-1 font-normal">
            Máximo {lengthLimit} caracteres: el texto no puede ser más largo.
          </p>
        )}
        {isLoading && (
          <span className="text-bg+3 absolute right-2 top-6 transform -translate-y-1/2">
            {/* <FiLoader size={20} className="animate-spin" />{" "} */}
            <Spinner size={20} />
          </span>
        )}
        {/* {error && (
          <p className="text-xs text-de+2 mt-1 font-normal">
            {touched && error}
          </p>
        )} */}
        {error && touched && (
          <p className="text-xs text-de+1 mt-1 font-normal">{error}</p>
        )}
      </div>
    );
  },
);
Textarea.displayName = "Textarea";

export { Textarea };
